module.exports = __webpack_public_path__ + "img/1507421612.8e3a5532.jpg";